<template>
  <DocumentList
    document-type="email"
    meta-name="Email"
  />
</template>

<script>
import { mapActions } from 'pinia';
import { useAppBase } from '@/stores/app/base';
import { useFilters } from '@/stores/filters/filters';
import DocumentList from '../DocumentList.vue';

export default {
  name: 'EmailList',
  components: {
    DocumentList,
  },
  emits: ['track-page-load'],
  mounted() {
    this.showFilterBarSettings({ route: this.$route.name, options: ['hideFilterChips'] });
    this.$emit('track-page-load', { page: 'Library: Email' });

    this.setFilterConfig({
      showMyJobs: true,
    });
  },
  methods: {
    ...mapActions(useAppBase, ['showFilterBarSettings']),
    ...mapActions(useFilters, ['setFilterConfig']),
  },
};
</script>
